import * as actionTypes from './actionTypes';
import admSvc from "../../axios-admsvc";
import { BASIC_SEARCH_TYPE, ADVANCE_SEARCH_TYPE, LS_BASIC_SEARCH_KEY, LS_ADVANCE_SEARCH_KEY, SESSION_SUPERUSER } from '../../shared/Constants';
import { resetMemResponse, selectImpactedMember } from './member';
import * as actions from './index';


export const doSearch = (searchCriteria, userType, source,) => {
    const url = source==='ImpactedForm' ? '/search/basic/V2.0' : '/search';
    return (dispatch, getState) => {
        const state = getState();
        dispatch(startSearch(searchCriteria));
        dispatch(actions.resetMemberError());
        let maxResults = userType===SESSION_SUPERUSER ? 100 : 25;
        return admSvc.post(url, searchCriteria, { headers:{'maxResults':maxResults } }).then(response => {
            setSearchRequestInLocalStore(searchCriteria, response)
            dispatch(searchUserSuccess(response.data));
            dispatch(resetMemResponse());
        }).catch(error => {
            clearSearchInLocalStore()
            dispatch(searchUsersFailed(error));
            dispatch(resetMemResponse())
        });
    }
}

export const searchUserSuccess = (response) => {
    return {
        type: actionTypes.SEARCH_USERS_SUCCESS,
        response: response
    }
}

export const searchUsersFailed = (error) => {
    return {
        type: actionTypes.SEARCH_USERS_FAILED,
        error: error
    }
}

export const startSearch = (searchCriteria) => {
    return {
        type: actionTypes.START_SEARCH,
        searchCriteria: searchCriteria
    }
}

export const setError = (error) => {
    return {
        type: actionTypes.SET_ERROR,
        error: error
    }
}

export const setSearchPageMessage = (message) => {
    return {
        type: actionTypes.SEARCH_PAGE_MESSAGE,
        message: message,
    }
}

export const resetSearchResults = () => {
    return {
        type: actionTypes.RESET_SEARCH_RESULT,
    }
}

const setSearchRequestInLocalStore = (request, response) => {

    if (response.data && response.data.payload) {
        switch(request.searchType) {
            case BASIC_SEARCH_TYPE:
                response.data.payload.length > 1 ? localStorage.setItem(LS_BASIC_SEARCH_KEY, btoa(JSON.stringify(request))) : localStorage.removeItem(LS_BASIC_SEARCH_KEY)
            break;
            
            case ADVANCE_SEARCH_TYPE:
                response.data.payload.length > 1 ? localStorage.setItem(LS_ADVANCE_SEARCH_KEY, btoa(JSON.stringify(request))) : localStorage.removeItem(LS_ADVANCE_SEARCH_KEY)
            break;

            default:
            break;
        }
    } 
}

const clearSearchInLocalStore = () => {
    localStorage.removeItem(LS_BASIC_SEARCH_KEY)
    localStorage.removeItem(LS_ADVANCE_SEARCH_KEY)
}

export const setImpactedMember = (data) => {
    return dispatch => {
        dispatch(selectImpactedMember(data, data.idType));
    }
}

export const resetSearchIndicators = () => {
    return {
        type: actionTypes.RESET_SEARCH_INDICATORS
    }
}
